module.exports = __webpack_public_path__ + "res/24-img_reward_b.24c73129e6f99001a7f93e66160c1c81.png";